/* eslint-disable */
import React, { useState, useRef, useEffect } from 'react';
import styles from '../../styles/components/controlVariations/ActivityDropdown.module.css';
import arrow from '../../assets/profile/Vector (13).png';

// Define the structure of an option
export interface DropdownOption {
	label: string;
	color: string;
	value: string;
}

interface Props {
	placeholder?: string;
	options: DropdownOption[]; // Updated to accept objects with colors
	selected?: string;
	onSelect: (option: DropdownOption) => void; // Passes back the full object
	width?: string;
	height?: string | number;
	menuMaxHeight?: string | number;
}

const ActivityDropdown: React.FC<Props> = ({
	placeholder = 'Select',
	options,
	selected,
	onSelect,
	width = '100%',
	height = '58px',
	menuMaxHeight = '235px',
}) => {
	const [open, setOpen] = useState(false);
	const [search, setSearch] = useState('');
	const ref = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const handler = (e: MouseEvent) => {
			if (ref.current && !ref.current.contains(e.target as Node)) {
				setOpen(false);
				setSearch('');
			}
		};
		document.addEventListener('mousedown', handler);
		return () => document.removeEventListener('mousedown', handler);
	}, []);

	// Filter based on the label property
	const filtered = options.filter(opt =>
		opt.label.toLowerCase().includes(search.toLowerCase())
	);

	return (
		<div className={styles.wrapper} style={{ width }} ref={ref}>
			<div
				className={`${styles.dropdown} ${open ? styles.active : ''}`}
				style={{ height }}
				onClick={() => setOpen(!open)}
			>
				<span className={styles.text}>{selected || placeholder}</span>
				<img
					src={arrow}
					className={open ? styles.rotate : ''}
					alt="arrow"
				/>
			</div>

			{open && (
				<div
					className={styles.menu}
					style={{ maxHeight: menuMaxHeight }}
				>
					{/* SEARCH INPUT */}
					<input
						className={styles.search}
						placeholder="Type to search..."
						value={search}
						onChange={e => setSearch(e.target.value)}
						autoFocus
					/>

					{/* LIST */}
					<div className={styles.optionsContainer}>
						{filtered.map((opt, i) => (
							<div
								key={i}
								className={styles.menuItem}
								onClick={() => {
									onSelect(opt);
									setOpen(false);
									setSearch('');
								}}
							>
								{/* Colored Square Icon */}
								<div
									className={styles.colorIcon}
									style={{ backgroundColor: opt.color }}
								/>
								{/* Text Label */}
								<span className={styles.itemLabel}>
									{opt.label}
								</span>
							</div>
						))}
					</div>

					{filtered.length === 0 && (
						<div className={styles.noResult}>No results found</div>
					)}
				</div>
			)}
		</div>
	);
};

export default ActivityDropdown;
